import axios from 'axios'
import store from '../store'
import { Message, MessageBox } from 'element-ui'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '/api',
  timeout: 15000
})

// 请求拦截
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    // ApiResponse 格式: { code, message, data }
    if (res.code !== undefined && res.code !== 200 && res.code !== 0) {
      Message.error(res.message || '操作失败')
      return Promise.reject(res)
    }
    return res.data !== undefined ? res.data : res
  },
  error => {
    if (error.response) {
      const { status, data } = error.response
      switch (status) {
        case 401:
          MessageBox.confirm('登录已过期，请重新登录', '提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('logout')
            location.href = '/#/login'
          }).catch(() => {})
          break
        case 403:
          Message.error('没有权限执行此操作')
          break
        case 404:
          Message.error('请求资源不存在')
          break
        case 500:
          Message.error('服务器内部错误')
          break
        default:
          Message.error((data && data.message) || '网络错误')
      }
    } else {
      Message.error('网络连接失败，请检查网络')
    }
    return Promise.reject(error)
  }
)

export default service
